import { css } from '@emotion/react';
import { navigate, PageProps } from 'gatsby';
import { useEffect } from 'react';
import { ContactPageTemplate } from '@/components/contact/ContactPageTemplate';
import { DownloadForm } from '@/components/form/DownloadForm';
import { Layout } from '@/components/general/Layout';
import { Seo } from '@/components/general/Seo';
import { pagesPath } from '@/lib/pagesPath';
import { useFormStorage } from '@/lib/use-form-storage';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => {
  const { getFormStorage, setFormStorage, cleanFormStorage } = useFormStorage();
  const formState = getFormStorage();

  useEffect(() => {
    if (formState) {
      return () => {
        cleanFormStorage();
      };
    }
  }, []);

  return (
    <Layout location={location}>
      <Seo
        title="資料請求"
        description="【Uniforce】IPO準備クラウドのサービス資料はこちらからダウンロードが可能です。"
      />
      <ContactPageTemplate
        title="資料請求"
        titleEn="DOWNLOAD"
        titleReadText={
          <>
            サービス概要・機能説明資料のダウンロードは
            <br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            />
            下記フォームへ必要情報をご入力ください。
          </>
        }
        sideTitleEn="Point"
        sideTitleJa="Uniforce導入のメリット"
        sideItems={[
          '上場経験がなくてもスムーズに準備を進められるようになる',
          '成長を視野に入れた内部統制構築・運用ができるようになる',
          '監査契約前に自社の内部統制状況をセルフチェックできる',
          '公認会計士によるIPO準備業務の徹底サポートを受けられる',
        ]}
        type="download"
      >
        <DownloadForm
          initFormState={{
            ...formState,
            agree_flag: false,
          }}
          submitHandler={async (state) => {
            setFormStorage(state);
            await navigate(pagesPath.download.confirmation.$url());
          }}
        />
      </ContactPageTemplate>
    </Layout>
  );
};

export default Page;
